module.exports = __webpack_public_path__ + "img/unlock.aac6776c.svg";